module.exports = __webpack_public_path__ + "img/SZstore.b92fcd51.jpg";